module.exports = __webpack_public_path__ + "static/img/6.7aa7e24.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/4/zh/6.png
// module id = 2tAd
// module chunks = 0